import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Tabs } from '@jouzen/ecom-components/v3/Tabs';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';
import Motion from '@/app/components/Motion';

import { partnershipIntegrationTabs } from '../_data/partnershipIntegrationData';

const PartnershipsIntegrations = () => {
  const t = useTranslations();

  const tabs = Object.keys(partnershipIntegrationTabs).map((tab) => ({
    label: t(tab),
  }));

  const tabPanels = Object.values(partnershipIntegrationTabs).map(
    (integrations) => ({
      content: (
        <Motion
          className="mt-8"
          initial={{ opacity: 0 }}
          transition={{ delay: 0.1, duration: 0.75, type: 'tween' }}
          whileInView={{ opacity: 1 }}
        >
          <LandingPageIntegrations integrations={integrations} />
        </Motion>
      ),
    }),
  );

  return (
    <section
      className="min-h-[740px] pt-20 pb-10 lg:mt-20 lg:pb-20"
      data-cy="partnerships-integrations"
    >
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Motion
            initial={{ opacity: 0 }}
            transition={{ delay: 0.2, duration: 0.75, type: 'tween' }}
            viewport={{ once: true }}
            whileInView={{ opacity: 1 }}
          >
            <Typography
              align="left"
              className="mb-4 lg:mb-16"
              Element="h2"
              variant="h3"
            >
              {t('partnerships_trusted_by')}
            </Typography>
          </Motion>
        </GridItem>
      </LayoutGrid>
      <Tabs
        scrollableTablist
        tabPanels={tabPanels}
        tabs={tabs}
        tabList={{
          tabWrapperComponent: LayoutGrid as unknown as () => JSX.Element,
          containerClass: 'col-end-main col-start-main',
        }}
      />
    </section>
  );
};

export default PartnershipsIntegrations;
